import styled from 'styled-components';

import { MAX_CONTENT_WIDTH } from '../../utils/constants';
import { FOOTER_BACKGROUND_COLOR, FOOTER_TEXT_COLOR, TRANSPARENT } from '../../utils/colors';
import { media } from '../../utils/media';

export const Container = styled.div`
  background-color: ${FOOTER_BACKGROUND_COLOR};
  color: ${FOOTER_TEXT_COLOR};
  padding: 30px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5em;
  letter-spacing: -0.08px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;

  ${media.desktop`
    flex-direction: row;
  `}

  @media print {
    display: none;
  }
`;

export const Main = styled.div`
  flex: 1;
  order: 2;
  width: 100%;
  max-width: ${MAX_CONTENT_WIDTH}px;
  margin: 0 auto;

  ${media.desktop`
    order: 1;
    padding: 62px 0 0 42px;
  `}
`;

export const Link = styled.a`
  text-decoration: none;
  color: ${FOOTER_TEXT_COLOR};
  border-bottom: 1px solid ${TRANSPARENT};
  transition: border-bottom-color 0.2s ease-in;

  &:hover {
    border-bottom-color: ${FOOTER_TEXT_COLOR};
  }
`;

export const CategoriesList = styled.ul`
  list-style: none;
  display: flex;
  justify-content: space-between;
  margin: 0;
`;

export const CategoriesListMobile = styled.ul`
  list-style: none;
  margin: 40px 0 0;
  display: flex;
  align-items: stretch;
`;

export const HalfWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
`;

export const Category = styled.li`
  width: 100%;

  &:not(:first-child) {
    margin-top: 30px;
  }

  ${media.desktop`
    width: 15%;

    &:not(:first-child) {
      margin-top: 0;
    }
  `}
`;

export const CategoryTitle = styled.h5`
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33em;
  letter-spacing: 0.6px;
  margin-bottom: 24px;
`;

export const CategoryLinksList = styled.ul`
  list-style: none;
  margin: 0;
`;

export const CategoryItem = styled.li`
  margin-bottom: 0.7em;
`;

export const CategoryLink = styled(Link)`
  cursor: pointer;
`;

export const SocialsList = styled.ul`
  order: 1;
  list-style: none;
  margin: 0;
  display: flex;
  flex-direction: row;

  ${media.desktop`
    width: 42px;
    order: 2;
    flex-direction: column;
  `}
`;

export const SocialItem = styled.li`
  &:not(:first-child) {
    margin-left: 15px;
    ${media.desktop`
      margin-left: 0;
    `}
  }

  ${media.desktop`
    margin-bottom: 12px;
  `}
`;

export const SocialLink = styled.a`
  display: block;
  width: 42px;
  height: 42px;
  cursor: pointer;
`;

export const ExtrasList = styled.ul`
  list-style: none;
  display: flex;
  margin: 80px 0 11px;
  flex-direction: row;
  flex-wrap: wrap;

  ${media.desktop`
    margin: 127px 0 11px;
  `}
`;

export const ExtraItem = styled.li`
  width: 50%;
  line-height: 1em;

  &:nth-child(2) {
    order: 3;
  }

  &:last-child {
    order: 2;
  }

  ${media.desktop`
    width: unset;
    margin: 0 20px 0 0;
    order: unset !important;

    &:last-child {
      margin: 0 0 0 auto;
    }
  `}
`;

export const ExtraLink = styled(Link)`
  font-size: 12px;
  font-weight: 500;
  line-height: 1em;
`;
